module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "dofMarquee",
    staticClass: ["dof-marquee"],
    style: _vm.wrapStyle
  }, [(_vm.direction === 'row') ? _c('div', {
    staticClass: ["wrap"],
    style: _vm.baseStyle
  }, [_c('div', {
    ref: "marquee1",
    staticClass: ["marquee1"],
    style: _vm.marquee1
  }, [_c('text', {
    staticClass: ["dof-text"],
    style: _vm.textStyle
  }, [_vm._v(_vm._s(_vm.text))])]), _c('div', {
    ref: "marquee2",
    staticClass: ["marquee2"],
    style: _vm.marquee2
  }, [_c('text', {
    staticClass: ["dof-text"],
    style: _vm.textStyle
  }, [_vm._v(_vm._s(_vm.text))])])]) : _vm._e(), (_vm.direction === 'column') ? _c('div', {
    style: _vm.baseStyle
  }, [_c('div', {
    ref: "wrapColumn",
    style: _vm.baseStyleWrap
  }, [_vm._l((_vm.text), function(txt) {
    return _c('text', {
      staticClass: ["text-item"],
      style: _vm.textStyle
    }, [_vm._v(_vm._s(txt))])
  }), _c('text', {
    staticClass: ["text-item"],
    style: _vm.textStyle
  }, [_vm._v(_vm._s(this.text[0]))])], 2)]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-04774a7f!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-marquee/index.vue
// module id = 570
// module chunks = 0 1